"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TermsAndConditionsValidatorProviders = void 0;
var _auth = require("@ori/auth");
var _configurationManager = require("@ori/configuration-manager");
var _environment = require("@ori/environment");
var _fetching = require("@ori/fetching");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _i18n = require("@ori/i18n");
var _logger = require("@ori/logger");
var _testidGenerator = require("@ori/testid-generator");
var _react = require("react");
var _constants = require("../../constants");
var _constantsGenerated = require("../../constants-generated");
var _jsxRuntime = require("react/jsx-runtime");
const TermsAndConditionsValidatorProviders = ({
  children
}) => {
  const {
    globalApiUrl
  } = (0, _configurationManager.useServiceUrls)(['globalApi', 'staticApi']);
  const {
    language
  } = (0, _i18n.useLanguage)();
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    formattedToken
  } = (0, _auth.useToken)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_testidGenerator.TestIdProvider, {
    team: _testidGenerator.Team.AcquisitionGrowth,
    project: _constantsGenerated.APP_NAME,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.ErrorBoundary, {
      areaName: "TermsAndConditionsValidator",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
        fallback: null,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fetching.SWRConfig, {
          value: _constants.swrConfig,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_globalApiClientReact.ApiClientProvider, {
            baseUrl: globalApiUrl,
            language: language,
            tenant: tenant,
            token: formattedToken,
            timeout: _constants.TIMEOUT_IN_MS,
            children: children
          })
        })
      })
    })
  });
};
exports.TermsAndConditionsValidatorProviders = TermsAndConditionsValidatorProviders;
